



















































































































































































































































































import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import { format, parseISO } from "date-fns";
import Success from "@/modals/Success.vue";
import TextLengthRestriction from "@/components/TextLengthRestriction.vue";
import CrmJobInfo from "@/modals/CrmJobInfo.vue";

export default Vue.extend({
	components: {
		Success,
		TextLengthRestriction,
      CrmJobInfo
	},
	data() {
		return {
			worker: {} as any,
         keywords: [] as any,
         keywordsText: '',
         defaultSearchArea: '',
         currentSearchArea: '',
         jobs: [] as any,
         jobsData: {} as any,
         jobsFound: false,
         loadingJobs: false,
         municipalities: [{"nimi": "","nimiSWE": "", "nimiENG": "", "voimassa": false,"maakunta": "x","maakuntaSWE": "x","maakuntaENG": "x"}],
         provinces: [{"maakunta": "","maakuntaSWE": "", "maakuntaENG": ""}],
         areaFilters: [] as any,
         selectedProvince: "",
         selectedMunicipality: "",
			provinceText: "",
			municipalityText: "",
         //educations            
         showSkillwordsLimit: 10,
			waitingEducations: false as boolean,
			educationSearchIndex: -1 as number,
			keywordsToAdd: [] as any,
			showOverlay: false as boolean,
         crmJobsData: [],
         modalJobId: 0,
         showTEjobs: false,
         showOtherJobs: false,
         TEjobsAmount: 0,
         otherJobsAmount: 0,
         firstOtherJobIndex: 0
      };
	},
	computed: {
		isMobile() {
			return store.state.isMobile;
		},      
		storeAuthObject() {
			return this.$store.state.strongAuth;
		},
		storeJwt() {
			return this.$store.state.jwt;
		},
	},
	methods: {
		dateDisplay(d: string): string {
			return format(parseISO(d), "d.M.Y");
		},
		getWorkerData() {
			axios.get("Itsepalvelu/user").then((resp) => {
				this.worker = resp.data;
				if(this.worker !== null && this.worker !== undefined){                         
					axios.get(`keywords/basicprofilekeywords/${true}`).then((r) => {
						this.keywords = r.data;                  
					});
				}
			});
      },
      getSearchArea(){
         var areaString = "";
         for(var i=0;i<this.areaFilters.length;i++){
            if(this.areaFilters[i].municipality !== undefined && this.areaFilters[i].municipality + '' !== ''){
               if(areaString + "" !== ""){areaString = areaString + ","}
               areaString = areaString + this.areaFilters[i].municipality;
            } else if(this.areaFilters[i].region !== undefined && this.areaFilters[i].region + '' !== ''){
               if(areaString + "" !== ""){areaString = areaString + ","}
               areaString = areaString + this.areaFilters[i].region;
            }            
         }
         return areaString;
      },
      getJobs() {
         this.TEjobsAmount = 0;
         this.otherJobsAmount = 0;
         this.showTEjobs = false;
         this.showOtherJobs = false;         
         this.jobs = [];         
         this.jobsFound = false;
         if(this.keywordsText+"" !==""){
            this.loadingJobs = true;
				this.showOverlay = true;
            this.currentSearchArea = this.getSearchArea() as string;

            let formData = new FormData();
            formData.append("keywordsText", this.keywordsText.toString() || '');
            formData.append("searchArea", this.currentSearchArea.toString() || '');

				axios.post("keywords/jobs",
						formData,
						{						
							headers: {
							'Content-Type': 'multipart/form-data'
							},
						}
					).then(response => {
						this.jobsData = response.data;
                  
                  //ADD CRM JOBS TO OBJECT:               
                  axios.post("keywords/jobsCrm",
                     formData,
                     {						
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        },
                     }
                  ).then(r => {                
                     this.crmJobsData = r.data;                  
                  })
                  .catch(function(){
                     console.log('Error receiving crm jobs!');
                  });   
                  //CRM JOBS ADDING ENDS
					
						this.loadingJobs = false;
						this.showOverlay = false;
					})
					.catch(function(){
						console.log('Error receiving jobs!');
					});  
              

			} else {				
				this.jobsData = [];
            this.crmJobsData = [];
			}

      },
		keywordsToText(){
			this.keywordsText = '';
			if(this.keywords !== undefined && this.keywords !== null){
				for (var i = 0; i < this.keywords.length; i++) {
					if(this.keywords[i].concept !== undefined && this.keywords[i].concept !== null){
						if(this.keywords[i].itsepalvelustaLisatty==true){
							if(this.keywordsText !== ''){
								this.keywordsText = this.keywordsText + ",";
							}
							this.keywordsText = this.keywordsText + this.keywords[i].concept;
						}
					}
				}
			}
		},
		getMunicipalities(){
			axios.get("keywords/kunnat").then((resp) => {
				this.municipalities = resp.data;
				if(this.municipalities !== undefined && this.municipalities !== null){
					//kerätään maakunnat               
					this.provinces = [];
					for(var i = 0; i< this.municipalities.length; i++){    
						if(this.municipalities[i].maakunta !== undefined && this.municipalities[i].maakunta !== null){
							var maakunta = this.municipalities[i].maakunta + "";
							//alert(maakunta);

							let maakuntaIndex;
							maakuntaIndex = this.provinces.findIndex((x: any) => x.maakunta === maakunta)

							if(maakuntaIndex < 0){
								
								const maakunta: any = {
									maakunta: this.municipalities[i].maakunta,						
									maakuntaSWE: this.municipalities[i].maakuntaSWE,                            
									maakuntaENG: this.municipalities[i].maakuntaENG                             
								}                              
								this.provinces.push(maakunta);

								

							}        

						}
					}

               switch (this.$store.state.lang) {
                  case 'fi':
                     this.provinces = this.provinces.sort((j1,j2) => j1.maakunta < j2.maakunta ? -1 : 1);
                     break;
                  case 'en': 
                     this.provinces = this.provinces.sort((j1,j2) => j1.maakuntaENG < j2.maakuntaENG ? -1 : 1);
                     break;
                  case 'se':
                     this.provinces = this.provinces.sort((j1,j2) => j1.maakuntaSWE < j2.maakuntaSWE ? -1 : 1);
                     break;
                  default:
                     this.provinces = this.provinces.sort((j1,j2) => j1.maakunta < j2.maakunta ? -1 : 1);
               }
            }
         
            this.getDefaultSearchArea();

         });

      },
      getDefaultSearchArea(){
         axios.get("keywords/defaultsearcharea").then((resp) => {
            this.defaultSearchArea = resp.data;
            
            this.selectedProvince = "";
            this.selectedMunicipality = "";
            var searchAreas = this.defaultSearchArea.split(',');
            for(var i=0;i<searchAreas.length;i++){
              
               if(this.isRegion(searchAreas[i].trim())){
              
                  //alert('region only:'+searchAreas[i].trim()+'');
                  const newAreaFilter: any = {
                     region: searchAreas[i].trim(),						
                     municipality: ''
                  }
                  this.areaFilters.push(newAreaFilter)
               } else {

                  var region = this.getMunicipalityRegion(searchAreas[i].trim());

                  //alert('region:'+region+',municipality:'+searchAreas[i].trim());
                  const newAreaFilter: any = {
                     region: region,						
                     municipality: searchAreas[i].trim()
                  }
                  this.areaFilters.push(newAreaFilter)
               }

            }
            //this.addAreaFilter();

         })
      },
      goToExternalPage(pageUrl: string){
         window.open(
              pageUrl, "_blank");
      },
      formatSearchArea(text: string){
         
         var searchItems = text.split(',');
         var translatedText = "";

			for(var i = 0; i < searchItems.length; i++)
			{
				if(searchItems[i].trim() + "" !== ""){
					if(i > 0){
						translatedText = translatedText + ", ";
					}
					translatedText = translatedText + this.translateArea(searchItems[i].trim());
				}
			}

         var returnText = translatedText.replace(/,(?=[^\s])/g, ", ");
         returnText = returnText.replace(/,(?=[^,]*$)/, " "+this.$t('and'))
         
         return returnText;
      },
      translateArea(text: string){
         var returnText = text;
         //if exists in provinces
         var provinceFound = this.provinces.filter((qObj)=>{return qObj.maakunta === text;}).pop();
         if(!(provinceFound==null || provinceFound==undefined)){            
            returnText = this.translatedProvince(provinceFound);
         }
         //if exists in municipalities
         var municipalityFound = this.municipalities.filter((qObj)=>{return qObj.nimi === text;}).pop();
         if(!(municipalityFound==null || municipalityFound==undefined)){            
            returnText = this.translatedMunicipality(municipalityFound);
         }
         return returnText;
      },
      isRegion(text: string){
         var region = false;
         //if exists in provinces         
         var provinceFound = this.provinces.filter((qObj)=>{return qObj.maakunta === text;}).pop();
         if(!(provinceFound==null || provinceFound==undefined)){            
            region = true;
         }         
         return region;
      },
      getMunicipalityRegion(text: string){
         var returnText = "unknown"
         var municipality = this.municipalities.filter((qObj)=>{return qObj.nimi === text;}).pop();
         if(!(municipality==null || municipality==undefined)){            
            returnText = municipality.maakunta;
         }
         return returnText;
      },
		getEducationByMissingSkills(missingSkills: any, jobIndex: number){

			// Jos koulutukset jo haettu niin toggletaan
			if(!!this.jobs[jobIndex].educationsSearched){
				this.jobs[jobIndex].showEducations = !this.jobs[jobIndex].showEducations;
				return;
			}

			var responseData: any;

			this.jobs[jobIndex].educations = [];
			this.jobs[jobIndex].educationsUpdatable = false;

			if(missingSkills <= 0){
				this.jobs[jobIndex].showEducations = true;
				this.jobs[jobIndex].educationsSearched = true;
			}
			
			if(missingSkills.length>0){    
				let formData = new FormData();
				formData.append("keywordsText", missingSkills.map((r: any) => r.name).join() || '');
				formData.append("searchArea", this.currentSearchArea.toString() || '');
				this.waitingEducations = true;
				this.educationSearchIndex = jobIndex;

				axios.post("keywords/educations",
						formData,
						{						
							headers: {
							'Content-Type': 'multipart/form-data'
							},
						}
					).then(response => {
						responseData = response.data;
						if(responseData.data !== undefined && responseData.data !== null){
							for (var i = 0; i < responseData.data.length; i++) {
								if(responseData.data[i].author==='mol'){
									this.jobs[jobIndex].educations = responseData.data[i].results 
                           
                           this.jobs[jobIndex].educations.forEach((edu: any) => {
                              Vue.set(edu, "showSkillWords", false);
                              
                              edu.reasoning = edu.reasoning.sort((a: any,b: any) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
                           })

								}
							}
						}
						this.jobs[jobIndex].educationsSearched = true;
						this.waitingEducations = false;
						this.educationSearchIndex = -1;
						this.jobs[jobIndex].showEducations = true;
					})
					.catch(function(){
						console.log('Error receiving educations!');
					});
			}
		},
		translatedMunicipality(municipality :any) :string {
			switch (this.$store.state.lang) {
				case 'fi':
					return municipality.nimi as string
				case 'en': 
					//return municipality.KuntaENG ? municipality.KuntaENG : municipality.Nimi as string
					return municipality.nimi as string
				case 'se':
					return municipality.nimiSWE ? municipality.nimiSWE : municipality.nimi as string
				default:
					return municipality.nimi as string
			}
		},
		translatedProvince(province :any) :string {
			switch (this.$store.state.lang) {
				case 'fi':
					return province.maakunta as string
				case 'en': 					
					return province.maakuntaENG ? province.maakuntaENG : province.maakunta as string
				case 'se':
					return province.maakuntaSWE ? province.maakuntaSWE : province.maakunta as string
				default:
					return province.maakunta as string
			}
		},
      goSkillboard(){			                  
         this.$router.push({name: 'Skillboard', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
      },
      addAreaFilter() {
         
			const newAreaFilter: any = {
            region: (this.selectedProvince || ''),						
            municipality: (this.selectedMunicipality || '')
         }                                       
         this.areaFilters.push(newAreaFilter)
			
			//Reset region and municipality selection:
			this.selectedProvince = "";
			this.provinceText = this.$t('select-region') + '';
         this.selectedMunicipality = "";
			this.municipalityText = this.$t('select-municipality') + '';
      
      },
      removeAreaFilter(filterIndex: number){         
         this.areaFilters.splice(filterIndex, 1);
      },   		
		toggleShowSkillwords(x: any){
			x.showSkillWords = !x.showSkillWords;
		},


		toggleAdd(skill: any){
			skill.chosenToAdd = !skill.chosenToAdd;
			if(!!skill.chosenToAdd){
				this.keywordsToAdd.push({
					Concept: skill.name,
					DisplayName: skill.name
				})
			}else{
				this.keywordsToAdd.some((r: any, index: number) => {
					if(r.Concept == skill.name){
						this.keywordsToAdd.splice(index, 1);
						return;
					}
				})
			}
		},

		async saveNewSkills(){

			const uniqueSkills: any = [...new Map(this.keywordsToAdd.map((item: any) =>[item['Concept'], item])).values()];
			const uniqueSkillsNames: String[] = uniqueSkills.map((r: any) => r.Concept.toLowerCase());

			let formData = new FormData();
         var skillsCount = uniqueSkills.length;

         formData.append("jobseekerId", (this.worker.uid).toString() || '');
         formData.append("profileId", "");         
         formData.append("deletedSkillsCount", "0");
         formData.append("skillsCount", skillsCount.toString() || "0");
         
			var i;
			for (i = 0; i < skillsCount;i++){			
				formData.append("skill"+i+"_concept", uniqueSkills[i].Concept || '');
            formData.append("skill"+i+"_displayname", uniqueSkills[i].DisplayName || '');
            formData.append("skill"+i+"_count", "0");
            formData.append("skill"+i+"_weight", "0");
            formData.append("skill"+i+"_relevancy", "0");
            formData.append("skill"+i+"_language", "");
            formData.append("skill"+i+"_rawdata", "");
				formData.append("skill"+i+"_selfserviceadded", "true");
			}

			await axios.post("keywords/saveKeywords",
				formData,
				{						
					headers: {
					'Content-Type': 'multipart/form-data'
					},
				}
			).then(response => {
				this.jobs.forEach((job: any) => {
					let removedSkills = job.missing_skills.filter((r: any) => {
						if(uniqueSkillsNames.includes(r.name.toLowerCase())){
							return r;
						}
					})

					removedSkills.forEach((skill: any) => job.reasoning.push(skill.name));

					job.missing_skills = job.missing_skills.filter((r: any) => {
						if(!uniqueSkillsNames.includes(r.name.toLowerCase())){
							return r;
						}
					})

					if(!!job.educationsSearched){
						job.educationsUpdatable = true;
					}
				})
				this.keywordsToAdd = [];
				this.showSuccess();
				(this.$refs.success as Vue & { autoHide: () => boolean }).autoHide();
			})
			.catch(function(){
				console.log('Error saving new skills!');
			});
		},
		forceUpdate(missingSkills: any, index: number){
			this.jobs[index].educationsSearched = false;
			this.getEducationByMissingSkills(missingSkills, index);
		},
		showSuccess(){
			this.$bvModal.show("success-modal");
		},
      provinceInputUpdate(event: any){
         var province = event.target.value;
         if(province+'' === ''){
				this.provinceText = this.$t('select-region') + '';
			} else {
				this.provinceText = this.translateArea(province);
         }
			//reset municipality select:
			this.selectedMunicipality = "";
			this.municipalityText = this.$t('select-municipality') + '';

			//focus efekti:
         var el: any;
         el = this.$refs['provinceText'];          
         if(!(el==undefined)){   
            el[0].focus();
         }        
      },
		municipalityInputUpdate(event: any){
         var municipality = event.target.value;
         if(municipality+'' === ''){
				this.municipalityText = this.$t('select-municipality') + '';
			} else {
				this.municipalityText = this.translateArea(municipality);
         }
			//focus efekti:
         var el: any;
         el = this.$refs['municipalityText'];          
         if(!(el==undefined)){   
            el[0].focus();
         }        
      },
      resetAreaSelection(){
         //Reset region and municipality selection:
			this.selectedProvince = '';
			this.provinceText = this.$t('select-region') + '';
         this.selectedMunicipality = '';
			this.municipalityText = this.$t('select-municipality') + '';        
      },
      showCrmJobInfo(jobId: number) {
			this.modalJobId = jobId;
         this.$bvModal.show("crm-job-info");         
		},

      toggleTEjobs(){
         this.showTEjobs = !this.showTEjobs;
      },
      toggleOtherjobs(){
         this.showOtherJobs = !this.showOtherJobs;
      }
	},
	mounted() {
		
	},
   async created() {
		this.getWorkerData();
      await this.$nextTick();
      this.getMunicipalities();
      await this.$nextTick();
      this.resetAreaSelection();
	},
	watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
						console.log(resp);
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
      keywords() {
         this.keywordsToText();         
      },   
      jobsData(){			
			if(this.jobsData.data !== undefined && this.jobsData.data !== null){
            for (var i = 0; i < this.jobsData.data.length; i++) {
					if(this.jobsData.data[i].author==='mol'){
            
                  this.jobs = this.jobsData.data[i].results;
						this.jobs.forEach((job: any) => {
							Vue.set(job, "showSkillWords", false);
							Vue.set(job, "showEducations", false);
							Vue.set(job, "educationsSearched", false);
							Vue.set(job, "educationsUpdatable", false);
							Vue.set(job, "educations", []);
							job.missing_skills = job.missing_skills.map((skill: any) => {
                        return {
                           name: skill,
                           chosenToAdd: false
                        }                     
						   })
                     job.missing_skills = job.missing_skills.sort((a: any,b: any) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
                     job.reasoning = job.reasoning.sort((a: any,b: any) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
						})
						// if(this.jobs.length > 0){
						// 	this.jobsFound = true;
						// }
					}

				}
            if(this.jobs.length > 0){
               this.jobsFound = true;

               this.firstOtherJobIndex = this.jobs.length;
               this.TEjobsAmount = this.jobs.length;

            } else {
               this.firstOtherJobIndex = 0;
            }
			}
		},
      crmJobsData(){
         this.otherJobsAmount = this.crmJobsData.length;
         for(var i = 0;i < this.crmJobsData.length;i++){
            let jobObj: any = JSON.parse(JSON.stringify(this.crmJobsData[i]));
            Vue.set(jobObj, "showSkillWords", false);
				Vue.set(jobObj, "showEducations", false);
				Vue.set(jobObj, "educationsSearched", false);
				Vue.set(jobObj, "educationsUpdatable", false);
				Vue.set(jobObj, "educations", []);
				// alert(jobObj.missing_skills);
            jobObj.missing_skills = jobObj.missing_skills.map((skill: any) => {
               return {
                  name: skill,
                  chosenToAdd: false
               }                     
            });
            jobObj.missing_skills = jobObj.missing_skills.sort((a: any,b: any) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
            jobObj.reasoning = jobObj.reasoning.sort((a: any,b: any) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
            this.jobs.push(jobObj);
         }
         if(this.jobs.length > 0){
            this.jobsFound = true;
         }
      }
      
	}
});
